export default __webpack_public_path__ + "/dist/images/whatsapp-sm.b757e73374c2b62925970c3808db1644.svg";